import React, { useEffect, useState } from "react";
import Modal from "react-bootstrap/Modal";
import "../../assets/styles/local/ProjectPopup.css";
import { fetchTranslationData } from "../../redux/actions/action";
import { useDispatch, useSelector } from "react-redux";
import { fetchScreenTranslations } from "../../utils/helpers/translations";

const CancelWarningModal = (props) => {
  const dispatch = useDispatch();
  const [FetchTranslationList, setFetchTranslationList] = useState({});
  const t = (key) => FetchTranslationList?.[key] || "";

  useEffect(() => {
    fetchScreenTranslations("Add-Project").then((data) =>
      setFetchTranslationList(data)
    );
  }, []);

  return (
    <>
      <Modal
        {...props}
        id="asc_project"
        dialogClassName="custum_projectPop"
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Header closeButto-n>
          <Modal.Title id="contained-modal-title-vcenter">
            {/* Modal heading */}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {/* <h4>Centered Modal</h4> */}
          <p className="text1">
            {/* This data will be removed from the system <br /> and cannot be undone. */}
            {t("This data will be removed from the system") ??
              "This data will be removed from the system"}
            <br />
            {t("and cannot be done.") ?? "and cannot be undone."}
          </p>
          {/* <p className="text2">Do you want to proceed?</p> */}
          <p className="proceed">
            {t("Do you want to proceed?") ?? "Do you want to proceed?"}
          </p>
        </Modal.Body>
        <Modal.Footer className="mt-3 gap-3">
          {/* <button className="asc_no" onClick={props.onHide}>No</button> */}
          <button className="asc_no" onClick={props.onHide}>
            {t("No") ?? "No"}
          </button>

          {/* <Button onClick={props.handleDelete}>yes</Button> */}
          <button className="asc_yes border-0" onClick={props.handleCancel}>
            {/* Yes */}
            {t("Yes") ?? "Yes"}
            {props.loading === true && (
              <div
                className="spinner-border spinner-border-sm ms-2"
                role="status"
              ></div>
            )}
          </button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default CancelWarningModal;
